import { render } from "./CardIcon.vue?vue&type=template&id=076e0758"
import script from "./CardIcon.vue?vue&type=script&lang=js"
export * from "./CardIcon.vue?vue&type=script&lang=js"
script.render = render

export default script